class RandomBubble {
  constructor({ channel, x, y, title, logo, speed = 0.5 }) {
    this.logo = logo;
    this.speed = speed;

    this.channel = channel;
    this.x = x;
    this.y = y;

    this.title = title;
  }

  next() {
    this.x = this.x + (1 * this.speed);
    return this;
  }

  respawn() {
    this.x = -110;
  }

  state() {
    return {
      x: this.x,
      y: this.y,
      title: this.title,
      logo: this.logo,
    };
  }
}

export default RandomBubble;
